import React from 'react'
import { Element } from 'react-scroll'
import SectionTitle2 from '../../sectionTitle/SectionTitle2'

const AISolutions = () => {
  return (
    <>
      <Element
        name="AISolutions"
        className="datatalent-section-gap bg-white"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 mt-0 px-0 px-md-4">
              <SectionTitle2
                classes = "text-center"
                title = "Key Focus Areas"
              />
            </div>
            <div className="col-12 mt-4 px-0 px-md-4">
              <p className="text-center section-description">Our platform brings the power of Edge AI to the field, greenhouse, and factory floor-enabling localized decision-making, real-time monitoring, and automation even in low-connectivity environments.</p>
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5">
              <div className="mea-key-features-card p-4 bg-white h-100">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/gear.svg`} alt="gear" />
                </div>
                <h5 className="mt-3 mb-3">Precision Agriculture</h5>
                <p className="mb-0">AI models for crop health monitoring, soil condition analysis, and resource-efficient yield optimization.</p>
              </div>  
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5">
              <div className="mea-key-features-card p-4 bg-white h-100">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/eye.svg`} alt="eye" />
                </div>
                <h5 className="mt-3 mb-3">Smart Irrigation & Resource Optimization</h5>
                <p className="mb-0">Edge-based water and energy monitoring systems that automate irrigation and reduce costs.</p>
              </div>
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5">
              <div className="mea-key-features-card p-4 bg-white h-100">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/no-axis-columns-increasing.svg`} alt="no-axis-columns-increasing" />
                </div>
                <h5 className="mt-3 mb-3">Livestock Health & Anomaly Detection</h5>
                <p className="mb-0">Behavior analysis and anomaly detection through embedded sensors and machine learning.</p>
              </div>  
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5">
              <div className="mea-key-features-card p-4 bg-white h-100">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/spark.svg`} alt="spark" />
                </div>
                <h5 className="mt-3 mb-3">Controlled Environment Agriculture</h5>
                <p className="mb-0">Real-time emissions tracking, microclimate optimization, and intelligent lighting control for greenhouses and indoor farms.</p>
              </div>  
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5">
              <div className="mea-key-features-card p-4 bg-white h-100">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/chart.svg`} alt="chart" />
                </div>
                <h5 className="mt-3 mb-3">Smart Food Processing & Storage</h5>
                <p className="mb-0">Real-time tracking of temperature, humidity, and vibration to reduce spoilage and ensure food safety in production and cold chain environments.</p>
              </div>
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5">
              <div className="mea-key-features-card p-4 bg-white h-100">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/shield-check.svg`} alt="shield-check" />
                </div>
                <h5 className="mt-3 mb-3">Post-Harvest Automation & Analytics</h5>
                <p className="mb-0">Vision-based quality grading, supply chain optimization, and traceability tools from field to retail.</p>
              </div>  
            </div>
          </div>
        </div>
      </Element>
    </>
  )
}

export default AISolutions;